import { useQuery } from '@apollo/client/react';

import { listFullEstablishments } from '../../services/EstablishmentService';

export const useFullEstablishments = (filter, { limit, offset }) => {
  const { data, loading, error } = useQuery(listFullEstablishments, {
    fetchPolicy: 'cache-and-network',
    variables: { filter, limit, offset }
  });

  return { establishments: data?.establishments ?? [], loading, error };
};
